export default __webpack_public_path__ + "static/media/card-fill.8fa7afab.svg";